import { CameraControls, CameraControlsImpl } from '@react-three/drei'
import { useThree } from '@react-three/fiber'
import { useEffect } from 'react'

import { useDebug } from '@hooks'
import { GamePhase, useGameStore } from '@stores'

import { GameCameraRig } from './GameCameraRig'
import { TitleCameraRig } from './TitleCameraRig'

export function CameraRig() {
  const debug = useDebug()
  const { controls } = useThree()
  const phase = useGameStore(state => state.phase)
  const levelComplete = useGameStore(state => state.levelComplete)

  useEffect(() => {
    if (!controls) return
    const cc = controls as CameraControlsImpl

    if (debug) return

    cc.mouseButtons.wheel =
      cc.mouseButtons.left =
      cc.touches.one =
      cc.touches.two =
      cc.mouseButtons.right =
      cc.mouseButtons.middle =
      // eslint-disable-next-line react-hooks/immutability
      cc.touches.three =
        CameraControlsImpl.ACTION.NONE
  }, [controls, levelComplete, debug])

  return (
    <>
      <CameraControls makeDefault />
      {phase >= GamePhase.PLAYING ? <GameCameraRig /> : <TitleCameraRig />}
    </>
  )
}
